import axios from "axios";
import React, { createContext, useEffect, useState } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import RequiredAuth from "./RequiredAuth/RequiredAuth";
import Loading from "./components/Loading/Loading";
import Categories from "./pages/Categories/Categories";
import Home from "./pages/Home/Home";
import Layout from "./pages/Layout/Layout";
import Login from "./pages/Login/Login";
import ManageClothes from "./pages/ManageClothes/ManageClothes";
import ManageCoupon from "./pages/ManageCoupon/ManageCoupon";
import ManageFeatured from "./pages/ManageFeatured/ManageFeatured";
import Orders from "./pages/Orders/Orders";
import Product from "./pages/Product/Product";
import { baseUrl } from "./service/api";
export const UserContext = createContext();

function App() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (token) {
      setLoading(true);
      axios
        .get(baseUrl + "/user/autoLogin", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          if (res.data?.result?.role === "admin") {
            setUser(res?.data?.result);
            setLoading(false);
            navigate("/dashboard");
          } else {
            navigate("/");
          }
        })
        .catch((error) => console.log(error)).finally(() => setLoading(false));
    }
  }, [token]);

  if (loading) {
    return <Loading />;
  }
  return (
    <div className="App">
      <UserContext.Provider value={{ user, setUser, loading, setLoading }}>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route
            path="/dashboard"
            element={
              <RequiredAuth>
                <Layout />
              </RequiredAuth>
            }
          >
            <Route
              index
              element={
                <RequiredAuth>
                  <Home />
                </RequiredAuth>
              }
            />
            <Route
              path="/dashboard/home"
              element={
                <RequiredAuth>
                  <Home />
                </RequiredAuth>
              }
            />
            <Route
              path="/dashboard/manage-products"
              element={
                <RequiredAuth>
                  <Product />
                </RequiredAuth>
              }
            />
            <Route
              path="/dashboard/manage-clothes"
              element={
                <RequiredAuth>
                  <ManageClothes />
                </RequiredAuth>
              }
            />
            <Route
              path="/dashboard/manage-categories"
              element={
                <RequiredAuth>
                  <Categories />
                </RequiredAuth>
              }
            />
            <Route
              path="/dashboard/manage-orders"
              element={
                <RequiredAuth>
                  <Orders />
                </RequiredAuth>
              }
            />
            <Route
              path="/dashboard/manage-featureds"
              element={
                <RequiredAuth>
                  <ManageFeatured />
                </RequiredAuth>
              }
            />
            <Route
              path="/dashboard/manage-coupons"
              element={
                <RequiredAuth>
                  <ManageCoupon />
                </RequiredAuth>
              }
            />
          </Route>
        </Routes>
      </UserContext.Provider>
      <ToastContainer />
    </div>
  );
}

export default App;
